<template>
  <div class="sub-menu">
    <transition name="slide">
      <div class="wrap" v-show="open">
        <div class="inner-section">
          <el-tabs
            class="submenu-tab"
            v-model="currentTab"
            ref="tabpanels"
            :style="{height:containerHeight+'px'}">

            <el-tab-pane name="popular" :class="{active:currentTab == 'popular'}">
              <span slot="label"><i class="icon mark"></i>{{$t('common.title.popularCity')}}</span>

              <transition name="slide-fade" v-on:enter="enter" appear>
                <div class="popular-cities" v-show="currentTab == 'popular'&&open">
                  <span v-for="city in popularCities" :key="city.id">
                    <router-link :to="{name:'city', params:{friendlyPath:city.friendlyPath, initScroll:true}}" @click.native="click">
                      {{ city.name }}
                    </router-link>
                  </span>
                </div>
              </transition>
            </el-tab-pane>

            <el-tab-pane
              v-for="(continent, continentIndex) in filteredCities"
              :label="continent.name"
              :key="continentIndex"
              :name="'tab-'+continentIndex"
              :class="{active:currentTab == 'tab-'+continentIndex}">
              <transition name="slide-fade" v-on:enter="enter" :ref="'tab-'+continentIndex">
                <div class="continents" v-show="currentTab == 'tab-'+continentIndex">
                  <ul>
                    <li v-for="(country, countryIndex) in continent.countries" class="country" :key="countryIndex">
                      <span class="name">{{ country.name }}</span>
                      <ul>
                        <li v-for="(city, idx) in country.cities" :key="idx" class="city">
                          <router-link :to="{name:'city', params:{friendlyPath:city.friendlyPath, initScroll:true}, query}" @click.native="click">
                            {{ city.name }}
                          </router-link>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </transition>
            </el-tab-pane>

          </el-tabs>

        </div>
      </div>
    </transition>
  </div>
</template>
<script>
  import {mapState} from 'vuex';
  import { EventBus } from '@/util/event-bus.js';

  export default {
    props: ['open', 'cityMenuMode', 'openedMenu'],

    data() {
      return {
        containerHeight: 85,
        currentTab: 'popular',
        enteredTab: null
      };
    },

    computed: {
      ...mapState({
        continents: ({cities}) => cities.continents,
        popularCities: ({cities}) => cities.favorite,
      }),
      query() {
        return this.cityMenuMode === 'accommodation' ? {type: 'accommodation'} : {}
      },
      filteredCities() {
        let list = JSON.parse(JSON.stringify(this.continents));

        if (this.cityMenuMode === 'accommodation') {
          list.map(continent => {
            continent.countries = continent.countries
              .map(country => {
                country.cities = country.cities.filter(city => city.containAccommodation);
                return country;
              })
              .filter(country => country.cities.length);
          });

          list = list.filter(continent => continent.countries.length);
        }
        return list
      }
    },

    methods: {
      click() {
        this.$parent.closeMenu()
      },
      enter(el) {
        this.containerHeight = el.offsetHeight + 70 // + (this.currentTab == 'popular'?20:0);
        this.enteredTab = el;
      },
    },

    watch: {
      open(val) {
        if (this.open) {
          this.$emit('opened', this.open);
        }
        setTimeout(() => {
          if (!this.open) this.$emit('opened', this.open);
          this.currentTab = this.open ? this.currentTab : 'popular';
          this.$refs['tabpanels'].$refs['nav'].$refs['tabs'][0].focus()
        }, 500);
      },
      cityMenuMode() {
        this.currentTab = 'popular';
        // this.enter(this.enteredTab);
      },
    },
    mounted() {
      EventBus.$on('keydown', (event) => {
        const { keyCode, which, shiftKey, target } =  event;
        const keycode = keyCode || which;

        if( keycode == 27 ) {
          this.$parent.closeMenu()
        }
        if( keycode === 9 && shiftKey ) {
          let tabs = this.$refs.tabpanels && this.$refs.tabpanels.$refs.nav && this.$refs.tabpanels.$refs.nav.$refs.tabs;
          if (tabs.indexOf(target) > -1) {
            event.preventDefault();
            event.stopPropagation();
            this.$parent.closeMenu();
          }
        }
      })
    },
    beforeDestroy() {
      EventBus.$off('keydown');
    }
  };
</script>

<style lang="scss" scoped src="./style.scss"></style>
